module.exports = __webpack_public_path__ + "static/media/macdonalds.30cdc657.svg";